import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const PageLinkLine = styled.div`
  display: block;
  width: 20ch;
  margin-top: ${tokens.spacer.x2pt5};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: 1600px) {
    width: 25ch;
  }
`;

export const DetailsTitle = styled.dt`
  display: inline-block;
  margin-right: 0.5ch;
  font-weight: normal;
`;

export const DetailsDefinition = styled.dd`
  display: inline;
`;

export const DetailsLine = styled.div`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin-bottom: ${tokens.spacer.x0pt5};
`;
